import type { Profile } from "@/hooks/useAuth";

/**
 * Lo stato di accesso di un account, calcolato COME LO CALCOLA IL SERVER.
 *
 * E' la stessa logica della edge function `chat` e del pannello admin
 * (InstallersPanel.statoDi): prima l'abbonamento, poi la prova. La copia e'
 * voluta e va tenuta fedele nei tre posti: quello che l'installatore trova
 * qui deve essere quello che il motore gli fa davvero.
 */

/** Gli stessi sette giorni che conta il motore. */
export const PROVA_GIORNI = 7;

export type StatoAccesso = "abbonato" | "prova" | "scaduto";

export function statoAccesso(profile: Pick<Profile, "brands" | "scadenza" | "created_at"> | null): StatoAccesso {
  if (!profile) return "scaduto";
  const scad = profile.scadenza ? new Date(profile.scadenza) : null;
  const scaduta = scad !== null && !Number.isNaN(scad.getTime()) && scad.getTime() <= Date.now();
  if ((profile.brands ?? []).length > 0 && !scaduta) return "abbonato";
  const inizio = profile.created_at ? new Date(profile.created_at).getTime() : NaN;
  if (!Number.isNaN(inizio) && Date.now() - inizio < PROVA_GIORNI * 86_400_000) return "prova";
  return "scaduto";
}
